import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { PaginationType1, DraftContent } from "components/ProfilePage/styled";
import Pagination from "components/Pagination";
import {
  Card,
  CardBody,
  CardImage,
  CardInfo,
  CardTime,
  CardTitle,
  CardTags,
  DraftActions,
  CardBodyInfo,
  CardWrapBorder,
} from "styles/MainCards.styled";
import { colors } from "styles/colors";
import Button from "shared/Button";
import { Spinner } from "styles/App.styled";
import { useStateMachine } from "little-state-machine";
import { updateAction, cleansAction, sortDirections, getImageName } from "helpers";
import Router from "next/router";
import { setDraftRecipes, deleteOwnRecipe } from "store/recipesReducer/recipesActions";
import { getDrafts, isDraftsLoading } from "store/recipesReducer/recipesSelectors";
import { NoImage } from "styles/Preview.styled";
import { clearErrors } from "store/alert";
import { timeConvert } from "../../../helpers/getFormatedTime";
import cloudfront from "helpers/cloudfront";

const OwnDrafts = () => {
  const dispatch = useDispatch();
  const ownDrafts = useSelector(getDrafts);
  const isLoading = useSelector(isDraftsLoading);
  const [currentPage, setCurrentPage] = useState(1);
  const { actions } = useStateMachine({ updateAction, cleansAction });

  const draftsPageRequest = (pagination) => {
    dispatch(setDraftRecipes(pagination));
  };

  const deleteDraft = (id) => {
    dispatch(deleteOwnRecipe(id));
  };

  const toFirstPage = async (item) => {
    let recipe = sortDirections(item);
    dispatch(clearErrors());
    sessionStorage.setItem("isTheFormOfRecipesSubmit", false);

    actions.updateAction(recipe);
    Router.push("/add-recipe");
  };

  const handlePage = (page) => setCurrentPage(page);

  return (
    <>
      {isLoading ? (
        <Spinner />
      ) : (
        <DraftContent>
          <CardWrapBorder>
            {ownDrafts.results.map((item) => (
              <Card key={item.id} className="horizontal">
                <CardImage>
                  {item.main_image ? (
                    <img
                      className="cloudfront"
                      src={cloudfront({ href: item.main_image, size: "medium" })}
                      alt={getImageName(item.main_image)}
                    />
                  ) : (
                    <NoImage />
                  )}
                </CardImage>
                <CardBody>
                  <CardBodyInfo>
                    <CardTitle>{item.title}</CardTitle>
                    <CardTime>
                      Time: <b>{timeConvert(item.total_time)}</b>
                    </CardTime>
                    <CardTime>
                      Yield:{" "}
                      <b>
                        {item.yields[0]?.number} {item.yields[0]?.type?.name}
                      </b>
                    </CardTime>
                    <CardTags>
                      {item.tags.map((item) => (
                        <span key={item.id}>{item.name.toLowerCase()},</span>
                      ))}
                    </CardTags>
                    <CardInfo>
                      {item.description && item.description.split("\n").map((val, i) => <p key={i}>{val}</p>)}
                    </CardInfo>
                  </CardBodyInfo>
                  <DraftActions>
                    <Button
                      bdButton={colors.WHITE}
                      color={colors.RED}
                      textColor={colors.WHITE}
                      stylType="outline"
                      text="Edit & Publish"
                      onClick={() => toFirstPage(item)}
                    />
                    <Button
                      bdButton={colors.WHITE}
                      color={colors.RED}
                      textColor={colors.WHITE}
                      text="Delete"
                      stylType="default"
                      onClick={() => deleteDraft(item.id)}
                    />
                  </DraftActions>
                </CardBody>
              </Card>
            ))}
          </CardWrapBorder>
          <PaginationType1>
            <Pagination
              handleDraftPage={handlePage}
              _page={currentPage}
              destination={"recipe_manager"}
              currentPage={2}
              stepClick={draftsPageRequest}
              countOfElements={ownDrafts.count}
              isDraft
            />
          </PaginationType1>
        </DraftContent>
      )}
    </>
  );
};

export default OwnDrafts;
